import { render, staticRenderFns } from "./LiveSelect.vue?vue&type=template&id=2c22c91b"
import script from "./LiveSelect.vue?vue&type=script&lang=js"
export * from "./LiveSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports